import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'mai-footer-action-bar',
  imports: [],
  templateUrl: './footer-action-bar.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterActionBar {}
